import { connect } from 'react-redux';

import SocialPost from './socialPost';

const mapStateToProps = state => ({
  moreInfoLink: state.app.pageData.cookieLayer.moreInfoLink
});

export default connect(mapStateToProps, null)(SocialPost);
